
import { throwError as observableThrowError, Observable } from 'rxjs';
import { Component, Inject, OnInit, Input, EventEmitter, OnDestroy, ViewChild, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';


//app
import { Site, Company } from 'solar-bo';
import { ListBaseComponent } from '@solar/shared/list-base.component';
import { SortHelper } from 'shtools';
import { SolarService } from '@solar/solar/services/solarservice.service';
import { CountryPickerService, ICountry } from 'basecomponents';
import { AppInjector } from 'base-models';
import { tableCol,ReqFilterHelper} from  'base-models';


@Component({
  selector: 'app-verifier-sites-list',
  templateUrl: './verifier-sites-list.component.html',
  styleUrls: ['./verifier-sites-list.component.scss']
})
export class VerifierSitesListComponent extends ListBaseComponent implements OnInit, OnChanges {

  _company_external: Company;
  @Input()
  set company_external(value: Company) {
    this._company_external=value;
      this.asignSites();
  }
  public countries: ICountry[];//a futuro mostrar paises

  constructor(public solarService: SolarService
  ) {

    super();
    const injector = AppInjector.getInjector();
    const countryPickerService = injector.get(CountryPickerService);
    countryPickerService.getCountries().subscribe(res => this.countries = CountryPickerService.sortCountries(res, "name.common"));

  }

  ngOnInit() {
    console.log("ngOnInit dialog", this.dialog);
    this.LoadSiteList();
    this.statusok = true;
  }


  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName === 'company_external') {
        console.log("changes" ,changes);
      } else {

      }
    }
  }

  private asignSites() {
    try {
      let sitesAssigned = [];
      if (this._company_external && this._company_external.sites) {
        sitesAssigned = this._company_external.sites;
        this.listFiltered.forEach(siteElem => {
          let isAssigned = sitesAssigned.find(site => site.id == siteElem.id_site);
          if (isAssigned) {
            if (isAssigned.hasOwnProperty("company_acl")) {
              let accesslevel: string[] = isAssigned.company_acl==null ? []: isAssigned.company_acl.access_level;
              let site_read = accesslevel.find(elem => elem == this.profileEnum.SITE_READ);
              if (site_read) {
                siteElem.read = true;
              }
              let site_edit = accesslevel.find(elem => elem == this.profileEnum.SITE_EDIT);
              if (site_edit) {
                siteElem.edit = true;
              }
            }
          }
        });

      }
    }
    catch (err) {
      
      this.showNotificationError("An error occurred while assigning permissions. ",err);
    }
  }


  /**
   * return company sites, all.
   */
  private LoadSiteList(): void {
    this.listerrmessage = "";
    this.loading = true;
    const filter = [tableCol.id, tableCol.name];
    this.solarService.companySitesGetAll(this.user.company.id, ReqFilterHelper.columnsFilter(filter))
      .subscribe(
        reslist => this.loadSiteListHandleResult(reslist)
        , err => this.handleError(err)
      );
  }

  private loadSiteListHandleResult(newlist: Site[]) {
    this.listerrmessage = "";
    this.loadinglist = false;
    newlist = SortHelper.sortMultiple(newlist, ["name"]);

    this.listFiltered = [];
    newlist.forEach(element => {
      this.listFiltered.push({ id_site: element.id, name: element.name, read: false, edit: false, closeonvalidation: false, validuntil: null })
    });

    this.asignSites();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  }

  selectionGetSelected(): any[] {
    return this.listFiltered;
  }

  uidescription(row: any) {
    return row.value.name;
  }
  uigetCountry(row: Site) {
    if (!row.info) {
      return "";
    }
    return CountryPickerService.uigetCountry(this.countries, row.info.country);
  }
}
